import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoubleChevronRightFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M4.96 2.001a2 2 0 0 1 1.417.582l12 12a2 2 0 0 1 0 2.83l-12 12a2.001 2.001 0 0 1-2.83-2.83l10.58-10.58-10.58-10.58a2 2 0 0 1 0-2.83 2 2 0 0 1 1.413-.592" />
      <path d="M15.033 2.001a2 2 0 0 1 1.417.582l12 12a2 2 0 0 1 0 2.83l-12 12a2.001 2.001 0 0 1-2.83-2.83l10.58-10.58-10.58-10.58a2 2 0 0 1 0-2.83 2 2 0 0 1 1.413-.592" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconDoubleChevronRightFilledSVG);
ForwardRef.displayName = "IconDoubleChevronRightFilled";
export { ForwardRef as IconDoubleChevronRightFilled };
